import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SystemService {
  private _apiURL = environment.production ? 'https://gocheck.fr/goperformbackend/public/api' : 'http://localhost:8008/api';
  private _webURL = environment.production ? 'https://gocheck.fr/goperformbackend/public' : 'http://localhost:8008';
  private _apiMobileURL = environment.production ? 'https://gocheck.fr/goperformbackend/public/api/mobile' : 'http://localhost:8008/api/mobile';
  
  constructor() { }

  get apiURL() {
    return this._apiURL;
  }

  get webURL() {
    return this._webURL;
  }

  get apiMobileURL() {
    return this._apiMobileURL;
  }
}
